<template>
    <div class="about" style="padding: 20px">
        <v-breadcrumbs :items="breadcrumbs">
            <template v-slot:divider>
                <v-icon>mdi-forward</v-icon>
            </template>
        </v-breadcrumbs>
        <h1>Modify Blog</h1>
        <v-form
                enctype="multipart/form-data"
                ref="form"
                v-model="valid"
        >
            <v-card outlined :loading="loading.general">
                <v-card-title>
                    General
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col
                                cols="12"
                                md="6"
                        >
                            <v-text-field
                                    v-model="dados.title"
                                    :counter="200"
                                    maxlength="200"
                                    label="Meta Title"
                                    required
                            ></v-text-field>
                        </v-col>
                        <v-col
                                cols="12"
                                md="6"
                        >
                            <v-text-field
                                    v-model="dados.description"
                                    :counter="200"
                                    maxlength="200"
                                    label="Meta Description"
                                    required
                            ></v-text-field>
                        </v-col>
                        <v-col
                                cols="12"
                                md="6"
                        >
                            <v-text-field
                                    v-model="dados.keywords"
                                    :counter="200"
                                    maxlength="200"
                                    label="Meta Keywords"
                                    required
                            ></v-text-field>
                        </v-col>
                        <v-col
                                cols="12"
                                md="6"
                        >
                            <v-text-field
                                    v-model="dados.url"
                                    :counter="200"
                                    maxlength="200"
                                    label="URL"
                                    required
                            ></v-text-field>
                        </v-col>
                        <v-col
                                cols="12"
                                md="6"

                        >
                            <v-switch v-model="dados.status" class="ma-4" label="Active"></v-switch>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
            <br>
            <v-card outlined :loading="loading.general">
                <v-card-title>
                    Image
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <!-- images -->
                        <v-col
                                cols="12"
                                md="12"
                                sm="12"
                                xs="12"

                        >
                            <v-file-input
                                    prepend-icon="mdi-camera"
                                    show-size
                                    counter
                                    small-chips
                                    v-model="file"
                                    label="Images (800x600)"
                                    accept="image/*"
                                    @change="onFileChange"
                            ></v-file-input>
                            <v-img :src="imageUrl.src" width="300"></v-img>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
            <br>
            <v-tabs
                    :grow="true"
                    background-color="indigo"
                    dark
            >
                <v-tab @click="language='en'">English</v-tab>
                <v-tab @click="language='pt'">Portuguese</v-tab>
                <v-tab @click="language='es'">Spanish</v-tab>
            </v-tabs>
            <v-card outlined :loading="loading.general">
                <v-card-text>
                    <v-row>
                        <!-- EN -->
                        <v-col
                                cols="12"
                                md="12"
                        >
                            <v-text-field
                                    v-if="language == 'en'"
                                    v-model="dados.title_en"
                                    :counter="200"
                                    maxlength="200"
                                    label="Title English"
                                    required
                            ></v-text-field>
                        </v-col>
                        <v-col
                                cols="12"
                                v-if="language=='en'"
                        >
                            <v-textarea
                                    outlined
                                    label="Short Description"
                                    v-model="dados.short_description_en"
                            ></v-textarea>
                        </v-col>
                        <v-col
                                cols="12"
                                v-if="language=='en'"
                        >
                            <span>Description</span>
                            <vue-editor v-model="dados.en"></vue-editor>
                        </v-col>
                        <!-- PT -->
                        <v-col
                                cols="12"
                                md="12"
                        >
                            <v-text-field
                                    v-if="language == 'pt'"
                                    v-model="dados.title_pt"
                                    :counter="200"
                                    maxlength="200"
                                    label="Title Portuguese"
                                    required
                            ></v-text-field>
                        </v-col>
                        <v-col
                                cols="12"
                                v-if="language=='pt'"
                        >
                            <v-textarea
                                    outlined
                                    label="Short Description"
                                    v-model="dados.short_description_pt"
                            ></v-textarea>
                        </v-col>
                        <v-col
                                cols="12"
                                v-if="language=='pt'"
                        >
                            <span>Description</span>
                            <vue-editor v-model="dados.pt"></vue-editor>
                        </v-col>
                        <!-- ES -->
                        <v-col
                                cols="12"
                                md="12"
                        >
                            <v-text-field
                                    v-if="language == 'es'"
                                    v-model="dados.title_es"
                                    :counter="200"
                                    maxlength="200"
                                    label="Title Spanish"
                                    required
                            ></v-text-field>
                        </v-col>
                        <v-col
                                cols="12"
                                v-if="language=='es'"
                        >
                            <v-textarea
                                    outlined
                                    label="Short Description"
                                    v-model="dados.short_description_es"
                            ></v-textarea>
                        </v-col>
                        <v-col
                                cols="12"
                                v-if="language=='es'"
                        >
                            <span>Description</span>
                            <vue-editor v-model="dados.es"></vue-editor>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
            <br>
            <div v-if="erro">
                <v-alert type="error" dense outlined  v-for="(item,index) in msg" :key="index">
                    {{ item }}
                </v-alert>
            </div>
            <div v-else>
                <v-alert type="success" dense outlined  v-for="(item,index) in msg" :key="index">
                    {{ item }}
                </v-alert>
            </div>
            <v-btn
                    :loading="loading.general"
                    :disabled="!valid"
                    color="success"
                    class="mr-4"
                    @click="validate"
            >
                Save
            </v-btn>
        </v-form>
    </div>
</template>
<script>
    import { VueEditor } from "vue2-editor";
    export default {
        components: {
            VueEditor
        },
        data: () => ({
            valid:true,
            loading:{
                general:false,
            },
            dados:{
                name:"",
                en:"",
                pt:"",
                es:"",
                title:"",
                description:"",
                keywords:"",
                url:"",
                status:1,
            },
            file: null,
            imageUrl: {},
            erro:true,
            msg:[],
            language:"en",
            breadcrumbs: [
                {
                    text: 'Dashboard',
                    disabled: false,
                    to: '/',
                },
                {
                    text: 'Blog',
                    disabled: false,
                    exact:true,
                    to: '/blog',
                },
                {
                    text: 'Blog Management',
                    disabled: true,
                    to: '/blog',
                },
            ],
        }),
        methods: {
            onFileChange() {
                var files = [];
                files = this.file;
                this.readAndPreview(files);
            },
            readAndPreview(file){
                if ( /\.(jpe?g|png|gif)$/i.test(file.name) ) {
                    let reader = new FileReader();
                    reader.onload = () => {
                        this.imageUrl ={
                            src:reader.result,
                            type:file.type
                        };
                    }
                    reader.readAsDataURL(file);
                }else{
                    console.log("Invalid Format");
                }
            },
            validate () {
                //this.loading.general = true;
                this.erro = false;
                this.dados.image = this.imageUrl;
                this.dados.id = this.$route.params.id;
                var arr = JSON.stringify(this.dados);
                this.$http.post("https://api.bestchoicevacation.com/blog/modify",arr,{
                    headers: {
                        'x-access-token': localStorage.hash
                    }
                }).then(response => {
                    this.loading.general = false;
                    this.msg = response.data.msg;
                    if(response.data.erro == '1'){
                        this.erro = true;
                    }else{
                        this.init();
                    }
                });

            },
            init(){
                this.$http.get("https://api.bestchoicevacation.com/blog/"+this.$route.params.id,{
                    headers: {
                        'x-access-token': localStorage.hash
                    }
                }).then(response =>{
                    this.loading.general = false;
                    this.dados.pt = response.data.pt;
                    this.dados.en = response.data.en;
                    this.dados.es = response.data.es;
                    this.dados.title = response.data.meta_title;
                    this.dados.title_en = response.data.title_en;
                    this.dados.title_es = response.data.title_es;
                    this.dados.title_pt = response.data.title_pt;
                    this.dados.description = response.data.meta_description;
                    this.dados.keywords = response.data.meta_keywords;
                    this.dados.url = response.data.meta_url;
                    this.dados.status = response.data.status;
                    this.imageUrl.src = response.data.images;
                    this.dados.short_description_en = response.data.short_description_en;
                    this.dados.short_description_es = response.data.short_description_es;
                    this.dados.short_description_pt = response.data.short_description_pt;
                });
            }
        },
        mounted(){
            this.init();
        }
    }
</script>